import bbc from '@/assets/pages/home/_01Hero/_01HeroTvLogos/Bbc.svg';
import ch4 from '@/assets/pages/home/_01Hero/_01HeroTvLogos/Ch4.svg';
import ch5 from '@/assets/pages/home/_01Hero/_01HeroTvLogos/Ch5.svg';
import itv from '@/assets/pages/home/_01Hero/_01HeroTvLogos/Itv.svg';
import sky from '@/assets/pages/home/_01Hero/_01HeroTvLogos/Sky.svg';

interface Props {
  className?: string;
}

export const _01HeroTvLogos = ({ className = '' }: Props): JSX.Element => {
  return (
    <div className={`flex items-center justify-center ${className}`}>
      <div className="inline-flex items-center justify-center gap-[33px] max-md:gap-[40px] px-[22.5px] py-[11px] max-md:px-[27px] max-md:py-[13px] rounded-[10px] [border:0.5px_dashed_#566167]">
        <img className="w-3.5 h-5 max-md:w-[16px] max-md:h-[23px]" alt="Ch4 Logo" src={ch4} />
        <img className="w-[27px] h-[13.97px] max-md:w-[32px] max-md:h-[17px]" alt="ITV Logo" src={itv} />
        <img className="w-[43px] h-3 max-md:w-[51px] max-md:h-[14px]" alt="BBC Logo" src={bbc} />
        <img className="w-[30px] h-[18px] max-md:w-[36px] max-md:h-[21px]" alt="Sky Logo" src={sky} />
        <img className="w-[13px] h-[18px] max-md:w-[16px] max-md:h-[21px]" alt="Ch5 Logo" src={ch5} />
      </div>
    </div>
  );
}; 